/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `Pitcher` - Pitcher
* `Catcher` - Catcher
* `First Baseman` - First Baseman
* `Second Baseman` - Second Baseman
* `Third Baseman` - Third Baseman
* `Shortstop` - Shortstop
* `Outfielder` - Outfielder
* `Center Fielder` - Center Fielder
* `Left Fielder` - Left Fielder
* `Right Fielder` - Right Fielder
* `Infielder` - Infielder
* `Designated Hitter` - Designated Hitter
* `Starting Pitcher` - Starting Pitcher
* `Closer` - Closer
* `Relief Pitcher` - Relief Pitcher
* `Pinch Hitter` - Pinch Hitter
* `Utility Player` - Utility Player
* `Pinch Runner` - Pinch Runner
* `Middle Relief Pitcher` - Middle Relief Pitcher
* `Setup Man` - Setup Man
* `Unspecified` - Unspecified
 */
export type PrimaryPositionBaseballEnum = typeof PrimaryPositionBaseballEnum[keyof typeof PrimaryPositionBaseballEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PrimaryPositionBaseballEnum = {
  Pitcher: 'Pitcher',
  Catcher: 'Catcher',
  First_Baseman: 'First Baseman',
  Second_Baseman: 'Second Baseman',
  Third_Baseman: 'Third Baseman',
  Shortstop: 'Shortstop',
  Outfielder: 'Outfielder',
  Center_Fielder: 'Center Fielder',
  Left_Fielder: 'Left Fielder',
  Right_Fielder: 'Right Fielder',
  Infielder: 'Infielder',
  Designated_Hitter: 'Designated Hitter',
  Starting_Pitcher: 'Starting Pitcher',
  Closer: 'Closer',
  Relief_Pitcher: 'Relief Pitcher',
  Pinch_Hitter: 'Pinch Hitter',
  Utility_Player: 'Utility Player',
  Pinch_Runner: 'Pinch Runner',
  Middle_Relief_Pitcher: 'Middle Relief Pitcher',
  Setup_Man: 'Setup Man',
  Unspecified: 'Unspecified',
} as const;
